import request from '@/utils/request';

function getCurrentRoleId() {
  if (typeof localStorage === 'undefined') {
    return '';
  }
  return localStorage.getItem('role_id') || '';
}

// 获取任务数量
export function getTaskCount(user_id, product_id, role_id) {
  return request({
    url: `/api/gateway/Campaign/GetCampaignEventTasks?user_id=${user_id}${role_id ? `&role_id=${role_id}` : ''}&is_executed=false&page_index=1&page_size=0`,
    method: 'get',
  });
}

// 获取任务列表
export function getTasks(user_id, product_id, campaign_event_id, isExecuted, executionType, pageNum, pageSize, role_id) {
  return request({
    url: `/api/gateway/Campaign/GetCampaignEventTasks?user_id=${user_id}${role_id ? `&role_id=${role_id}` : ''}&is_executed=${isExecuted}${executionType ? `&execution_type=${executionType}` : ''}${product_id ? `&product_id=${product_id}` : ''}${campaign_event_id ? `&campaign_event_id=${campaign_event_id}` : ''}&page_index=${pageNum}&page_size=${pageSize}`,
    method: 'get',
  });
}

// 获取任务列表（仅任务，不含医生）
export function getCampaignEvents(user_id, product_id, role_id) {
  return request({
    url: `api/gateway/Campaign/GetCampaignEvents?user_id=${user_id}${role_id ? `&role_id=${role_id}` : ''}${product_id ? `&product_id=${product_id}` : ''}&page_index=1&$orderby=event_start_date desc`,
    method: 'get',
  });
}

// 获取当前用户任务统计及活动顶部医生
export function getMyCampaignEventStat() {
  return request({
    url: `/api/gateway/Campaign/GetMyCampaignEventStat`,
    method: 'get',
  });
}

// 获取医生任务列表
export function getPhysicianTasks(physician_id, user_id, product_id, isExecuted, pageNum, pageSize, role_id) {
  return request({
    url: `/api/gateway/Campaign/GetCampaignEventTasks?physician_id=${physician_id}&user_id=${user_id}${role_id ? `&role_id=${role_id}` : ''}&is_executed=${isExecuted}&${product_id ? `&product_id=${product_id}` : ''}&page_index=${pageNum}&page_size=${pageSize}`,
    method: 'get',
  });
}

// 获取任务执行统计 gateway/Campaign/GetCampaignEventTaskStat
export function getTaskStat(campaign_event_id, product_id) {
  return request({
    url: `/api/gateway/Campaign/GetCampaignEventTaskStat?campaign_event_id=${campaign_event_id}${product_id ? `&product_id=${product_id}` : ''}`,
    method: 'get',
  });
}

// 执行/忽略任务
export function executeTask(execution_type, campaign_event_id, physician_id, user_id, user_name, territory_id, role_id = getCurrentRoleId()) {
  return request({
    url: `/api/standard/odata/CampaignEventExecutions`,
    method: 'post',
    data: {
      campaign_event_id,
      physician_id,
      user_id,
      user_name,
      territory_id,
      role_id,
      execution_type,
      execution_time: new Date().toISOString(),
    },
  });
}

// 执行/忽略任务（覆盖原来）
export function reExecuteTask(campaign_event_execution_id, execution_type, campaign_event_id, physician_id, user_id, user_name, territory_id, role_id = getCurrentRoleId()) {
  return request({
    url: `/api/standard/odata/CampaignEventExecutions('${campaign_event_execution_id}')`,
    method: 'patch',
    data: {
      campaign_event_id,
      physician_id,
      user_id,
      user_name,
      territory_id,
      role_id,
      execution_type,
      execution_time: new Date().toISOString(),
    },
  });
}

// 返回event_type为segment的任务
export function getSegmentTasks() {
  return request({
    url: `/api/standard/odata/CampaignEvents?$filter=event_type eq 'segment'&$select=campaign_event_name,event_type,campaign_event_id,start_date&$orderby=start_date desc`,
    method: 'get',
  });
}
